var _circle, _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgQuickShip = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1053.4 371.9",
  width: "1em",
  height: "1em"
}), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 470.6,
  cy: 301.2,
  r: 65.1,
  transform: "rotate(-45.001 470.576 301.197)"
})), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 858,
  cy: 302.1,
  rx: 65.2,
  ry: 65.6
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1008 8.4H810.6L679.5 292H773c14.5-55.5 43.1-76.4 87.3-76.4 44.3 0 71.8 20.9 82.1 76.4h65.6l34.2-109L1008 8.4zm-182.6 145 45.7-113.1H969l20.6 113.1H825.4zM314.8 4.2l-39.2 63.4h87.2V81h-95.4l8.1-13.4H124.7V81h142.7l-28.9 46.7h74.3v13.4h-82.5l8.1-13.4H158v13.4h72.1L197 194.5H11.2v13.4h177.5l8.6-13.4h65.4v13.4h-73.9l-50.1 81h247.5c11.5-52.3 46-71.4 86.4-71.4s74.1 24.8 81.8 71.4h99l134-284.6-472.6-.1z"
})));
export default SvgQuickShip;